import {
    GET_STEWARD_CONFLICTS_REQUEST,
    GET_STEWARD_CONFLICTS_SUCCESS,
    GET_STEWARD_CONFLICTS_FAILURE,
    STEWARD_RESOLVE_REQUEST,
    STEWARD_RESOLVE_SUCCESS,
    STEWARD_RESOLVE_FAILURE,
} from "./actions";

const initialState = {
    // Unresolved field conflicts for the cluster being reviewed
    // ([{ fieldId, fieldName, values: [{ value, dataObjectId, dataSetId }] }]).
    fieldConflicts: [],
    conflictsLoading: false,
    getConflictsResult: { success: true },
    resolving: false,
    resolveResult: { success: true },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_STEWARD_CONFLICTS_REQUEST:
            return { ...state, conflictsLoading: true, fieldConflicts: [] };
        case GET_STEWARD_CONFLICTS_SUCCESS:
            return { ...state, conflictsLoading: false, fieldConflicts: action.payload, getConflictsResult: { success: true } };
        case GET_STEWARD_CONFLICTS_FAILURE:
            return { ...state, conflictsLoading: false, getConflictsResult: { success: false, ...action.payload } };
        case STEWARD_RESOLVE_REQUEST:
            return { ...state, resolving: true };
        case STEWARD_RESOLVE_SUCCESS:
            return { ...state, resolving: false, resolveResult: { success: true } };
        case STEWARD_RESOLVE_FAILURE:
            return { ...state, resolving: false, resolveResult: { success: false, ...action.payload } };
        default:
            return state;
    }
};
